export default "__VITE_ASSET__1KK387s___"